import { render, staticRenderFns } from "./income_reality.vue?vue&type=template&id=2a38b4c6&"
import script from "./income_reality.vue?vue&type=script&lang=js&"
export * from "./income_reality.vue?vue&type=script&lang=js&"
import style0 from "./income_reality.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports